// extracted by mini-css-extract-plugin
export var orderDetails = "_og-2";
export var orderImage = "_og-1";
export var orderMeta = "_og-3";
export var orderSummary = "_og-0";
export var rightArrow = "_og-4";